module.exports = __webpack_public_path__ + "img/37698-011.a6124101.jpg";